angular.module('cimerFrontEndApp').controller('DisplayLogicModalCtrl', ['$scope', '$uibModalInstance', 'question', 'parentOptions', 'idFactory', function ($scope, $uibModalInstance, question, parentOptions, idFactory) {
    "use strict";

    var emptyQuestionBranch = {
        QuestionBranch: {
            QuestionBranchID: null,
            TempBranchID: null,
            getID: function () { return this.QuestionBranchID || this.TempBranchID; }
        },
        tempID: null,
        ParentQuestions: []
    };

    var emptyParentQuestion = {
        ParentQuestionID: null,
        ParentQuestionTextPlainText: '',
        ScaleAnswers: [],
        ParentQuestionType: null,
        shortPrompt: '',
        scaleAnswerOptions: []
    };

    $scope.showHelpText = false;
    $scope.questionText = "";
    if (question.details.hasOwnProperty("QuestionPromptText")) { // Processing for matrix questions
        $scope.questionText = question.details.QuestionPromptTextPlain;
        $scope.questionBranches = angular.copy(question.details.Questions[0].QuestionBranches);
    }
    else { // Processing for non-matrix questions
        $scope.questionText = question.details.TextPlain;
        $scope.questionBranches = angular.copy(question.details.QuestionBranches);
    }
    
    // If there are no existing question branches on the question, add an empty one to start
    if ($scope.questionBranches.length === 0) {
        $scope.questionBranches.push(angular.copy(emptyQuestionBranch));
        $scope.questionBranches[0].ParentQuestions.push(angular.copy(emptyParentQuestion));
    }

    $scope.parentQuestions = $scope.questionBranches[0].ParentQuestions;
    $scope.parentOptions = angular.copy(parentOptions);

    $scope.addNewBranch = function () {
        $scope.parentQuestions.push(angular.copy(emptyParentQuestion));
    };

    $scope.removeParentQuestion = function (index) {
        $scope.parentQuestions.splice(index, 1);
        if ($scope.parentQuestions.length === 0) {
            $scope.parentQuestions.push(angular.copy(emptyParentQuestion));
        }
    };

    $scope.scaleAnswerDropdownSettings = {
        externalIdProp: '',
        idProp: '_id',
        displayProp: 'shortPrompt',
        enableSearch: false,
        showCheckAll: false,
        showUncheckAll: false,
        showEnableSearchButton: false,
        smartButtonMaxItems: 3,
        template: '<span ng-attr-title="{{option.AnswerTextPlainText}}">{{option.shortPrompt}}</span>',
        buttonClasses: 'btn btn-default'
    };

    $scope.scaleAnswerDropdownText = {
        buttonDefaultText: 'Select Answers'
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.save = function () {
        // We're only going to pass back the array of parent questions/scale answers and let the section deal with assigning them back to the child and parent question(s)
        var parentQuestions = [];
        for (var i = 0; i < $scope.parentQuestions.length; i++) {
            // Remove the properties we were only using for modal display
            delete $scope.parentQuestions[i].shortPrompt;
            for (var l = 0; l < $scope.parentQuestions[i].scaleAnswerOptions.length; l++) {
                delete $scope.parentQuestions[i].scaleAnswerOptions[l]._id;
            }
            delete $scope.parentQuestions[i].scaleAnswerOptions;

            // If they left the question prompt box empty or the scale answer box empty, ignore it
            if ($scope.parentQuestions[i].ParentQuestionID === null || $scope.parentQuestions[i].ScaleAnswers.length === 0) {
                continue;
            }
            var pq = parentQuestions.find(q => q.ParentQuestionID === $scope.parentQuestions[i].ParentQuestionID);
            // If we don't already have it in the parentQuestions array, add it
            if (pq === undefined) {
                var scaleAnswers = $scope.parentQuestions[i].ScaleAnswers;
                for (var k = 0; k < scaleAnswers.length; k++) {
                    // Remove the shortPrompt and _id property
                    delete scaleAnswers[k].shortPrompt;
                    delete scaleAnswers[k]._id;
                    // If it is not already being used for display logic (doesn't have an ID), assign it one
                    if (scaleAnswers[k].QuestionBranch.getID() === null) {
                        scaleAnswers[k].QuestionBranch.TempBranchID = idFactory.getNewQuestionBranchID();
                    }
                }

                parentQuestions.push($scope.parentQuestions[i]);
            }
            else {
                // Check to make sure we add any scale answers we don't already have
                var parent = $scope.parentQuestions[i];
                for (var j = 0; j < parent.ScaleAnswers.length; j++) {
                    if (pq.ScaleAnswers.find(sa => sa.getID() === parent.ScaleAnswers[j].getID()) === undefined) {
                        var sa = parent.ScaleAnswers[j];
                        // Remove the temporary properties if needed
                        if (sa.shortPrompt !== undefined) { delete sa.shortPrompt; }
                        if (sa._id !== undefined) { delete sa._id; }
                        // If it isn't already being used in display logic (has an ID), assign it one
                        if (sa.QuestionBranch.getID() === null) {
                            sa.QuestionBranch.TempBranchID = idFactory.getNewQuestionBranchID();
                        }
                        // Add the scale item to the parent question
                        pq.ScaleAnswers.push(parent.ScaleAnswers[j]);
                    }
                }
            }
        }
        $uibModalInstance.close(parentQuestions);
    };

}]);